<template>
  <app-main-layout>
    <!--  -->
    <!-- Main Left Menu  -->
    <template v-slot:left>
      <app-left-nav />
    </template>
    <!--  -->
    <!-- Main Top Menu -->
    <template v-slot:top>
      <app-top-nav padded>
        <template v-slot:left>
          <el-page-header nav-title> Invitations </el-page-header>
        </template>
        <template v-slot:center>
          <span>
            <!-- Search -->
          </span>
        </template>
        <template v-slot:right>
          <el-button
            @click="inviteTalent"
            round
            type="primary"
            icon="el-icon-plus"
            f-w-600
            >Invite Talent</el-button
          >
          <!-- Other buttons -->
        </template>
      </app-top-nav>
    </template>
    <!--  -->
    <!-- Main Content -->
    <template v-slot:main>
      <!-- Modal -->
      <InviteTalentModal @close="notInviting" :isOpen="isCreating" />
      <!-- Charts -->
      <!--  -->
      <!-- Loaded invitations -->
      <div app-main-content>
        <InvitationsList :loading="loading" :invitations="invitations"></InvitationsList>
      </div>
    </template>
    <!--  -->
    <!--  -->
    <!--  -->
  </app-main-layout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import InvitationsList from "./components/invitations-list.component.vue";
import InviteTalentModal from "./components/invite-talent-modal.vue";
@Options({
  components: { InvitationsList, InviteTalentModal },
})
export default class extends Vue {
  isCreating = false;
  /**
   *
   */
  inviteTalent() {
    this.isCreating = true;
  }
  notInviting() {
    console.log("Should close the modal");
    this.isCreating = false;
  }
  /**
   * @returns invitations
   */
  get invitations() {
    return this.$store.state.invitations.invitations;
  }

  /**
   * @returns invitations
   */
  get loading() {
    return this.$store.state.invitations.loading;
  }

  mounted() {
    this.$store.dispatch("invitations/fetch");
  }
}
</script>

<style lang="scss"></style>
